export default __webpack_public_path__ + "static/media/404errorImg.7db1c206.webp";